import { Link } from "react-router-dom";
import { useT } from "@/contexts/I18nContext";

export function NotFoundPage() {
  const t = useT();
  return (
    <div className="mx-auto max-w-lg px-6 py-24 text-center">
      <h1 className="font-display text-2xl text-ink">{t("error.notFound.title")}</h1>
      <p className="mt-3 text-ink-muted">{t("error.notFound.body")}</p>
      <Link to="/" className="mt-6 inline-block text-sm text-cue-green underline">
        {t("nav.dashboard")}
      </Link>
    </div>
  );
}
